<template>
    <div v-if="acquiring">
        <div class="by-center">
            <div class="text-h6 mb-8" id="title">{{ acquiring.data.entityTitle }}</div>

            <dl>
                <dt>
                    <v-icon>mdi-phone</v-icon>
                </dt>
                <dd>{{ numberFormatted }}</dd>

                <dt class="mb-8">
                    <v-icon>mdi-map-marker</v-icon>
                </dt>
                <dd>{{ acquiring.data.entityAddress }}</dd>

                <dt>ИНН</dt>
                <dd>{{acquiring.data.inn}}</dd>

                <dt>{{ ogrnTitle }}</dt>
                <dd>{{ ogrn }}</dd>

                <dt>Банк</dt>
                <dd>{{ acquiring.data.bank }}</dd>

                <dt>БИК</dt>
                <dd>{{ acquiring.data.bik }}</dd>

                <dt>К/с №</dt>
                <dd>{{ acquiring.data.numKS }}</dd>
                <dt>Р/с №</dt>
                <dd id="account">{{ acquiring.data.numRS }}</dd>
            </dl>
        </div>

        <div class="by-center">
            <h6 class="text-h6 mb-8 mt-3">Способы оплаты</h6>

            <p class="text-body-2">Сервис приёма оплаты предоставлен банком 
            <a class="accent--text" href="https://yookassa.ru/" target="_blank">yookassa.ru</a>.
            </p>

            <p class="text-body-2">
            Для выбора оплаты товара с помощью банковской карты на соответствующей странице необходимо нажать кнопку Оплата заказа банковской картой. Оплата происходит через ООО НКО «ЮМани» с использованием банковских карт.
            </p>

            <p class="text-body-2">
            Для оплаты (ввода реквизитов Вашей карты) Вы будете перенаправлены на платёжный шлюз ООО НКО «ЮМани». Соединение с платёжным шлюзом и передача информации осуществляется в защищённом режиме с использованием протокола шифрования SSL. В случае если Ваш банк поддерживает технологию безопасного проведения интернет-платежей Verified By Visa, MasterCard SecureCode, MIR Accept, J-Secure, для проведения платежа также может потребоваться ввод специального пароля.
            </p>

            <p class="text-body-2">
            Настоящий сайт поддерживает 256-битное шифрование. Конфиденциальность сообщаемой персональной информации обеспечивается ООО НКО «ЮМани». Введённая информация не будет предоставлена третьим лицам за исключением случаев, предусмотренных законодательством РФ. Проведение платежей по банковским картам осуществляется в строгом соответствии с требованиями платёжных систем МИР, Visa Int., MasterCard Europe Sprl, JCB.
            </p>

            <p class="text-body-2">
            В соответствии с ФЗ «О защите прав потребителей» в случае, если Вам оказана услуга или реализован товар ненадлежащего качества, платеж может быть возвращен на банковскую карту, с которой производилась оплата. Порядок возврата средств уточняйте у организатора закупки, возврат которой необходим.
            </p>

            <p class="text-body-2">
            <b>Принимаем оплаты с помощью банковских карт:</b> VISA, MasterCard, МИР, JCB.
            <img src="../../public/assets/images/card.png" style="width:300px;display:block;margin:2rem auto;"/>
            </p>


            <h6 class="text-h6 my-8">Отказ от услуги</h6>
            <p class="text-body-2">Если по каким-либо причинам Вы решили отказаться от исполнения договора о выполнении работ (оказании услуг),
                то можете сделать это в соответствии с Законом РФ «О защите прав потребителей» от 07.02.1992 № 2300-1.
            </p>
            <p class="text-body-2">Потребитель вправе расторгнуть договор о выполнении работы (оказании услуги) в любое время, уплатив
                исполнителю часть цены пропорционально части выполненной работы (оказанной услуги) до получения извещения
                о расторжении указанного договора и возместив исполнителю расходы, произведенные им до этого момента в
                целях исполнения договора, если они не входят в указанную часть цены работы (услуги).
            </p>

            <ul class="text-body-2 decimal-list">
                <li>Потребитель при обнаружении недостатков оказанной услуги вправе по своему выбору потребовать:
                    <ol class="symbol-list">
                        <li>Безвозмездного устранения недостатков;</li>
                        <li>Соответствующего уменьшения цены;</li>
                    </ol>
                </li>
                <li>Потребитель вправе предъявлять требования, связанные с недостатками оказанной услуги, если они обнаружены
                    в течение гарантийного срока, а при его отсутствии в разумный срок, в пределах двух лет со дня принятия
                    оказанной услуги;</li>
                <li>При отказе от исполнения договора потребитель имеет право на возврат выплаченных исполнителю денежных сумм;</li>
                <li>Исполнитель отвечает за недостатки услуги, на которую не установлен гарантийный срок, если потребитель
                    докажет, что они возникли до ее принятия им или по причинам, возникшим до этого момента.</li>
            </ul>

            <p class="text-body-2">
                Срок возврата товара надлежащего качества составляет 30 дней с момента получения товара.
                Возврат переведённых средств, производится на ваш банковский счёт в течение 5-30 рабочих дней 
                (срок зависит от банка, который выдал вашу банковскую карту).
            </p>

            <h6 class="text-h6 my-8">Доставка</h6>
            <p class="text-body-2">
                В момент оплаты заказа вы сможете выбрать удобный для вас Пункт Выдачи из списка предложенных. 
                Также там будут доступны альтернативные способы доставки, настроенные организатором закупки.
            </p>
            <p class="text-body-2">
                Список способов доставки может изменяться от закупки к закупке.
            </p>
        </div>

        <div class="by-center">
            <h6 class="text-h6 mt-3 mb-3">Договор оферты</h6>

            <div class="text-body-2">
            <p v-if="acquiring.data.contractOfferUrl">
                <a
                    class="accent--text link-desktop"
                    :href="acquiring.data.contractOfferUrl"
                    download
                >
                    скачать
                </a>
                <a
                    class="accent--text link-mobile"
                    :href="acquiring.data.contractOfferUrl"
                >
                    скачать
                </a>
            </p>

            <h4
                v-else
                class="red--text"
            >
                не загружен
            </h4>
            </div>

            <h6 class="text-h6 mt-10 mb-3">Порядок проведения оплат и возвратов</h6>

            <div class="text-body-2">
            <p v-if="acquiring.data.paymentReturnProcedureUrl">
                <a
                    class="accent--text link-desktop"
                    :href="acquiring.data.paymentReturnProcedureUrl"
                    download
                >
                скачать
                </a>
                <a
                    class="accent--text link-mobile"
                    :href="acquiring.data.paymentReturnProcedureUrl"
                    download
                >
                скачать
                </a>
            </p>

            <h4
                v-else
                class="red--text"
            >
                не загружен
            </h4>
            </div>

            <h6 class="text-h6 mt-10 mb-3">Цены товаров и описание услуг</h6>

            <div class="text-body-2">
            <p v-if="acquiring.data.priceServiceDescriptionUrl">
                <a
                    class="accent--text link-desktop"
                    :href="acquiring.data.priceServiceDescriptionUrl"
                    download
                >
                скачать
                </a>
                <a
                    class="accent--text link-mobile"
                    :href="acquiring.data.priceServiceDescriptionUrl"
                >
                скачать
                </a>
            </p>

            <h4
                v-else
                class="red--text"
            >
                не загружен
            </h4>
            </div>

            <div v-if="acquiring.data.privacyPolicyUrl">

            <h6 class="text-h6 mt-10 mb-3">Политика конфиденциальности</h6>

            <div class="text-body-2">
                <p>
                    <a
                        :href="acquiring.data.privacyPolicyUrl"
                        class="accent--text link-desktop"
                        download
                    >
                        скачать
                    </a>
                    <a
                        :href="acquiring.data.privacyPolicyUrl"
                        class="accent--text link-mobile"
                    >
                        скачать
                    </a>
                </p>
            </div>
            </div>
        </div>
    </div>
</template>
  
<script>
    import {getAcquiring} from '@/composables/acquiring';
    import {formatPhoneNumber} from '../services/utils';

    export default {
        name: 'About',
        components: {},
        computed: {
            numberFormatted () {
                return formatPhoneNumber(this.acquiring.data.phone)
            },
            ogrn () {
                return this.acquiring.data.type === 'ip' ? this.acquiring.data.ogrnip : this.acquiring.data.ogrn;
            },
            ogrnTitle () {
                return this.acquiring.data.type === 'ip' ? 'ОГРНИП' : 'ОГРН';
            },
            acquiring: getAcquiring
        },
    }
</script>
  
<style scoped lang="scss">
    dl {
        display: grid;
            grid-template-columns: auto 1fr;
    }

    dt {
        font-weight: 500;
        min-width: 0;
        margin-bottom: .5em;
    }

    dd {
        margin: 0 0 1em 1em;
    }

    .decimal-list li {
        list-style: decimal;
    }

    .symbol-list li {
        list-style: lower-latin;
    }

    .image-block {
        align-items: center;
        margin: -10px;
    }

    .p-method {
        display: block;
        margin: 0 auto;
        max-height: 40px;
    }

    .link-desktop {
        display: block;
    }

    .link-mobile {
        display: none;
    }

    @media (max-width: 768px) {
        .link-desktop {
            display: none;
        }

        .link-mobile {
            display: block;
        }
    }
</style>